<template>
  <v-layout row wrap>
    <v-container fluid>
      <!-- Form -->
      <v-dialog
        v-model="json_data.status"
        fullscreen
        transition="dialog-bottom-transition"
        :overlay="false"
      >
        <v-card>
          <v-toolbar dark color="primary">
            <v-tooltip bottom>
              <v-btn slot="activator" icon dark @click="closeDialog">
                <v-icon>close</v-icon>
              </v-btn>
              <span>{{ $t('close') }}</span>
            </v-tooltip>
            <v-toolbar-title>
              {{ json_data.save_type == 'create' ? $t('menu.TaxSetting') :
              $t('menu.TaxSetting') }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn flat dark @click="json_data.save_type == 'create' ? onSave() : onUpdate()">
              <v-icon>save</v-icon>
              <span class="px-2">{{ json_data.save_type == 'create' ? $t('create') : $t('save') }}</span>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container fluid px-1>
              <v-layout row wrap>
                <v-flex xs12>
                  <h2>{{$t('Calculation_income')}}</h2>
                  <v-layout row wrap>
                    <v-flex lg1 md2 sm2 xs3 pa-3>
                      <h4>{{$t('Year_tax')}}</h4>
                    </v-flex>
                    <v-flex lg2 md2 sm2 xs9 px-1>
                      <v-menu
                        ref="menu"
                        :close-on-content-click="false"
                        v-model="menu"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <v-text-field
                          slot="activator"
                          v-model="years"
                          prepend-icon="event"
                          readonly
                        ></v-text-field>
                        <v-date-picker ref="picker" v-model="year" @input="save" reactive no-title></v-date-picker>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex lg1 md3 sm3 xs6 pa-3>
                      <span>{{$t('Otherincome')}}</span>
                      <!-- <v-text-field :label="$t('Otherincome')" v-model="model_tax.name" ></v-text-field> -->
                    </v-flex>
                    <v-flex lg2 md3 sm3 xs6 px-3>
                      <v-text-field placeholder="0" type="number" v-model="income" />
                    </v-flex>
                  </v-layout>
                  <h4>{{$t('Lessexpenses')}}</h4>
                  <v-layout row wrap>
                    <v-flex lg1 md2 sm2 xs3 pa-3>
                      <span>{{$t('Rate')}}</span>
                    </v-flex>
                    <v-flex lg1 md2 sm2 xs8 px-1>
                      <v-text-field
                        label="Solo"
                        placeholder="tax"
                        type="number"
                        v-model="taxsetting.less_exp_rate"
                        solo
                      />
                    </v-flex>
                    <v-flex lg1 md2 sm2 xs1 px-1>
                      <span>%</span>
                    </v-flex>
                    <v-flex lg1 md2 sm2 xs3 px-1>
                      <span>{{$t('max_value')}}</span>
                    </v-flex>
                    <v-flex lg2 md2 sm2 xs8 px-1>
                      <v-text-field
                        label="Solo"
                        placeholder="0"
                        type="number"
                        v-model="taxsetting.less_exp_base"
                        solo
                      />
                    </v-flex>
                    <v-flex lg2 md2 sm2 xs1 px-1>
                      <span>{{$t('baht')}}</span>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex lg3 md3 sm3 xs12>
                      <span>{{$t('Spouseallowance')}}</span>
                    </v-flex>
                    <v-flex lg1 md3 sm3 xs4>
                      <span>{{$t('max_value')}}</span>
                    </v-flex>
                    <v-flex lg2 md3 sm3 xs6>
                      <v-text-field
                        label="Solo"
                        placeholder="0"
                        type="number"
                        v-model="taxsetting.reduce_spouse"
                        solo
                      />
                    </v-flex>
                    <v-flex lg3 md3 sm3 xs2 pa-2>
                      <span>{{$t('baht')}}</span>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex lg3 md3 sm3 xs4>
                      <span>{{$t('Childallowance')}}</span>
                    </v-flex>
                    <v-flex lg1 md3 sm3 xs2>
                      <span>{{$t('max_value')}}</span>
                    </v-flex>
                    <v-flex lg2 md3 sm3 xs5>
                      <v-text-field
                        label="Solo"
                        placeholder="0"
                        type="number"
                        v-model="taxsetting.reduce_child_base"
                        solo
                      />
                    </v-flex>
                    <v-flex lg3 md3 sm3 xs1 pa-2>
                      <span>{{$t('baht')}}</span>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex lg3 md3 sm3 xs4>
                      <span>{{$t('Homemortgageinterest')}}</span>
                    </v-flex>
                    <v-flex lg1 md3 sm3 xs2>
                      <span>{{$t('max_value')}}</span>
                    </v-flex>
                    <v-flex lg2 md3 sm3 xs5>
                      <v-text-field
                        label="Solo"
                        placeholder="0"
                        type="number"
                        v-model="taxsetting.reduce_insurance_base"
                        solo
                      />
                    </v-flex>
                    <v-flex lg3 md3 sm3 xs1 pa-2>
                      <span>{{$t('baht')}}</span>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex lg3 md3 sm3 xs12>
                      <span>{{$t('Parentalcareallowance')}}</span>
                    </v-flex>
                    <v-flex lg1 md3 sm3 xs12>
                      <span>{{$t('max_value')}}</span>
                    </v-flex>
                    <v-flex lg2 md3 sm3 xs12>
                      <v-text-field
                        label="Solo"
                        placeholder="0"
                        type="number"
                        v-model="taxsetting.reduce_parent_base"
                        solo
                      />
                    </v-flex>
                    <v-flex lg3 md3 sm3 xs12 pa-2>
                      <span>{{$t('baht')}}</span>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex lg3 md3 sm3 xs12>
                      <span>{{$t('Disabilityallowance')}}</span>
                    </v-flex>
                    <v-flex lg1 md3 sm3 xs12>
                      <span>{{$t('max_value')}}</span>
                    </v-flex>
                    <v-flex lg2 md3 sm3 xs12>
                      <v-text-field
                        label="Solo"
                        placeholder="0"
                        type="number"
                        v-model="taxsetting.reduce_handucap_base"
                        solo
                      />
                    </v-flex>
                    <v-flex lg3 md3 sm3 xs12 pa-2>
                      <span>{{$t('baht')}}</span>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex lg3 md3 sm3 xs12>
                      <span>{{$t('Lifeinsurancepremium')}}</span>
                    </v-flex>
                    <v-flex lg1 md3 sm3 xs12>
                      <span>{{$t('max_value')}}</span>
                    </v-flex>
                    <v-flex lg2 md3 sm3 xs12>
                      <v-text-field
                        label="Solo"
                        placeholder="0"
                        type="number"
                        v-model="taxsetting.reduce_inc_residence_base"
                        solo
                      />
                    </v-flex>
                    <v-flex lg3 md3 sm3 xs12 pa-2>
                      <span>{{$t('baht')}}</span>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex lg3 md3 sm3 xs12>
                      <span>{{$t('Healthinsurancepremiumsforparents')}}</span>
                    </v-flex>
                    <v-flex lg1 md3 sm3 xs12>
                      <span>{{$t('max_value')}}</span>
                    </v-flex>
                    <v-flex lg2 md3 sm3 xs12>
                      <v-text-field
                        label="Solo"
                        placeholder="0"
                        type="number"
                        v-model="taxsetting.reduce_parent_insurance_base"
                        solo
                      />
                    </v-flex>
                    <v-flex lg3 md3 sm3 xs12 pa-2>
                      <span>{{$t('baht')}}</span>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex lg3 md3 sm3 xs12>
                      <span>{{$t('LongTermEquityFund')}}</span>
                    </v-flex>
                    <v-flex lg1 md3 sm3 xs12>
                      <span>{{$t('max_value')}}</span>
                    </v-flex>
                    <v-flex lg2 md3 sm3 xs12>
                      <v-text-field
                        label="Solo"
                        placeholder="0"
                        type="number"
                        v-model="taxsetting.reduce_ltf"
                        solo
                      />
                    </v-flex>
                    <v-flex lg3 md3 sm3 xs12 pa-2>
                      <span>{{$t('baht')}}</span>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex lg3 md3 sm3 xs12>
                      <span>{{$t('Pensionlifeinsurance')}}</span>
                    </v-flex>
                    <v-flex lg1 md3 sm3 xs12>
                      <span>{{$t('max_value')}}</span>
                    </v-flex>
                    <v-flex lg2 md3 sm3 xs12>
                      <v-text-field
                        label="Solo"
                        placeholder="0"
                        type="number"
                        v-model="taxsetting.reduce_long_insurance"
                        solo
                      />
                    </v-flex>
                    <v-flex lg3 md3 sm3 xs12 pa-2>
                      <span>{{$t('baht')}}</span>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex lg3 md3 sm3 xs12>
                      <span>{{$t('Employee_buy_RMF')}}</span>
                    </v-flex>
                    <v-flex lg1 md3 sm3 xs12>
                      <span>{{$t('max_value')}}</span>
                    </v-flex>
                    <v-flex lg2 md3 sm3 xs12>
                      <v-text-field
                        label="Solo"
                        placeholder="0"
                        type="number"
                        v-model="taxsetting.reduce_rmf"
                        solo
                      />
                    </v-flex>
                    <v-flex lg3 md3 sm3 xs12 pa-2>
                      <span>{{$t('baht')}}</span>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <h3>{{$t('Otherallowances')}}</h3>
                  </v-layout>
                  <v-layout row v-for="(item,index) in data_allowances" :key="index">
                    <v-flex lg4 md4 sm4 xs4 pa-2>
                      <v-text-field label="name" v-model="item.name" hide-details />
                    </v-flex>
                    <v-flex lg3 md4 sm4 xs4 pa-2>
                      <v-text-field :label="$t('max_value')" v-model="item.max" hide-details />
                    </v-flex>
                    <v-flex lg4 md4 sm4 xs4 pa-3>
                      <span>{{$t('Maximum_value')}}</span>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-layout row>
                  <v-flex lg4 md4 sm4 xs4 pa-2>
                    <v-btn color="success" @click="plusallowances()">
                      <v-icon :size="16">fa-plus</v-icon>
                      <span class="ml-2">{{$t('Add_step')}}</span>
                    </v-btn>
                    <v-btn color="warning" @click="delallowances()">
                      <v-icon :size="16">fa-minus</v-icon>
                      <span class="ml-2">{{$t('Step_down')}}</span>
                    </v-btn>
                  </v-flex>
                </v-layout>

                <v-flex xs12>
                  <h2>{{$t('Tax_structure')}}</h2>
                  <v-layout row wrap v-for="(item, index) in data_tax" :key="index">
                    <v-flex md2 sm2 xs5 px-1>
                      <v-text-field
                        :label="$t('Fromtheamount')"
                        v-model="item.from_value"
                        hide-details
                      />
                    </v-flex>
                    <v-flex md1 sm1 xs1 px-1>
                      <h1 class="text-xs-center" style="padding-top: 0.5rem;">-</h1>
                    </v-flex>
                    <v-flex md2 sm2 xs5 px-1>
                      <v-text-field :label="$t('Toamount')" v-model="item.to_value" hide-details />
                    </v-flex>
                    <v-flex md1 sm1 xs1 px-1>
                      <h1 class="text-xs-center" style="padding-top: 0.5rem;">=</h1>
                    </v-flex>
                    <v-flex md2 sm2 xs4 px-1>
                      <v-text-field :label="$t('Rate')" v-model="item.tax" hide-details />
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap py-2>
                    <v-flex xs12>
                      <v-btn color="success" @click="plusTax()">
                        <v-icon :size="16">fa-plus</v-icon>
                        <span class="ml-2">{{$t('Add_step')}}</span>
                      </v-btn>
                      <v-btn color="warning" @click="delTax()">
                        <v-icon :size="16">fa-minus</v-icon>
                        <span class="ml-2">{{$t('Step_down')}}</span>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 text-xs-right>
                  <v-btn color="success" @click="onUpdate()">
                    <v-icon>save</v-icon>
                    <span class="px-2">{{ $t('save')}}</span>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </v-layout>
</template>
<script>
/* eslint-disable */
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import SettingService from "@/services/SettingService";
import moment, { locale } from "moment";

export default {
  props: {
    json_data: Object
  },
  watch: {
    json_data(val) {
      if (val.data != null) {
        this.form_model = val.data;
        //console.log("form_model" ,this.form_model)
      } else {
        //this.$refs.form.resetValidation();
      }
    }
  },
  data: () => ({
    switch1: true,
    jsontest: {
      year_tax: "2000",
      tax_detail: [
        {
          name: "add_income",
          type: 1,
          percent: 0,
          max: 0
        },
        {
          name: "expensed",
          type: 0,
          percent: 50,
          max: 100000
        },
        {
          name: "spouse",
          type: 0,
          percent: 0,
          max: 100000
        },
        {
          name: "childen",
          type: 0,
          percent: 0,
          max: 90000
        },
        {
          name: "residence",
          type: 0,
          percent: 0,
          max: 100000
        },
        {
          name: "parent",
          type: 0,
          percent: 0,
          max: 100000
        },
        {
          name: "handicapped",
          type: 0,
          percent: 0,
          max: 100000
        },
        {
          name: "insurance",
          type: 0,
          percent: 0,
          max: 100000
        },
        {
          name: "insurance",
          type: 0,
          percent: 0,
          max: 100000
        },
        {
          name: "parent_insurance",
          type: 0,
          percent: 0,
          max: 100000
        },
        {
          name: "long_insurance",
          type: 0,
          percent: 0,
          max: 100000
        },
        {
          name: "LTF",
          type: 0,
          percent: 0,
          max: 100000
        },
        {
          name: "RMF",
          type: 0,
          percent: 0,
          max: 100000
        },
        {
        name: "ค่าซ่อมแซมบ้าน",
        type: 0,
        percent: 0,
        max: 100000
        }
      ],
      tax_cal: [
        {
          basiccal: 150000,
          deductline: 0,
          from_value: 0,
          line_number: 0,
          tax: 0,
          to_value: 150000
        },
        {
          basiccal: 150000,
          deductline: 7500,
          from_value: 150001,
          line_number: 1,
          tax: 5,
          to_value: 300000
        },
        {
          basiccal: 200000,
          deductline: 20000,
          from_value: 300001,
          line_number: 2,
          tax: 10,
          to_value: 500000
        },
        {
          basiccal: 250000,
          deductline: 37500,
          from_value: 500001,
          line_number: 3,
          tax: 15,
          to_value: 750000
        },
        {
          basiccal: 250000,
          deductline: 50000,
          from_value: 750001,
          line_number: 4,
          tax: 20,
          to_value: 1000000
        },
        {
          basiccal: 1000000,
          deductline: 250000,
          from_value: 1000001,
          line_number: 5,
          tax: 25,
          to_value: 2000000
        },
        {
          basiccal: 3000000,
          deductline: 900000,
          from_value: 2000001,
          line_number: 6,
          tax: 30,
          to_value: 5000000
        },
        {
          basiccal: 0,
          deductline: 0,
          from_value: 5000001,
          line_number: 7,
          tax: 35,
          to_value: 0
        }
      ],
      creator_code: "Tester"
    },
    data_tax: [],
    // data_allowances:[
    //   {
    //     type:0,
    //     percent:0,
    //     name:null,
    //     max:0,
    //   },
    //   {
    //     type:0,
    //     percent:0,
    //     name:null,
    //     max:0,
    //   },
    //   {
    //     type:0,
    //     percent:0,
    //     name:null,
    //     max:0,
    //   }
    // ],
    data_allowances: [],
    //date: new Date().toISOString().substr(0, 7),
    year: null,
    years: "2019",
    menu: false,
    income: 0,
    jsondatatax: {
      year_tax: null,
      tax_detail: [],
      tax_cal: [],
      creator_code: null
    },
    tax_detail: [
      {
        name: "add_income",
        type: 1,
        percent: 0,
        max: 0
      },
      {
        name: "expensed",
        type: 0,
        percent: 50,
        max: 100000
      },
      {
        name: "spouse",
        type: 0,
        percent: 0,
        max: 100000
      },
      {
        name: "childen",
        type: 0,
        percent: 0,
        max: 90000
      },
      {
        name: "residence",
        type: 0,
        percent: 0,
        max: 100000
      },
      {
        name: "parent",
        type: 0,
        percent: 0,
        max: 100000
      },
      {
        name: "handicapped",
        type: 0,
        percent: 0,
        max: 100000
      },
      {
        name: "insurance",
        type: 0,
        percent: 0,
        max: 100000
      },
      {
        name: "parent_insurance",
        type: 0,
        percent: 0,
        max: 100000
      },
      {
        name: "long_insurance",
        type: 0,
        percent: 0,
        max: 100000
      },
      {
        name: "LTF",
        type: 0,
        percent: 0,
        max: 100000
      },
      {
        name: "RMF",
        type: 0,
        percent: 0,
        max: 100000
      },
    ],
    taxsetting: {
      less_exp_rate: 50,
      less_exp_base: 100000,
      reduce_person: 60000,
      reduce_spouse: 0,
      reduce_child_base: 30000,
      reduce_parent_base: 30000,
      reduce_handucap_base: 30000,
      reduce_insurance_base: 100000,
      reduce_parent_insurance_base: 15000,
      reduce_inc_residence_base: 100000,
      reduce_ltf: 0,
      reduce_long_insurance: 0,
      reduce_rmf: 0
    }
  }),
  watch: {
    menu(val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker = "YEAR"));
      //new Date().getFullYear()
    }
  },
  created: function() {
    this.commitSetToolbar({ patternTool: "2" });
    this.getTaxSetting();
    this.getTaxDetail();
    this.data_allowances.push(
      {
        type: 0,
        percent: 0,
        name: null,
        max: 0
      },
      {
        type: 0,
        percent: 0,
        name: null,
        max: 0
      },
      {
        type: 0,
        percent: 0,
        name: null,
        max: 0
      }
    );
  },
  destroyed: function() {
    this.commitToggleAlertDialog({ status: false, message: Object });
  },
  computed: {
    ...mapState("app", ["showLoading"])
  },
  methods: {
    ...mapActions("app", ["commitSetToolbar", "commitSetShowLoading"]),
    ...mapActions("alert", ["commitToggleAlertDialog"]),
    closeDialog() {
      this.clearForm();
      this.$emit("close-dialog");
    },
    getTaxSetting() {
      this.commitSetShowLoading(true);
      SettingService.getTaxSetting()
        .then(res => {
          console.log(res);
          this.data_tax = [];
          if (res.data.content.length > 0) {
            //this.data_tax = res.data.content;
            for (let index = 0; index < res.data.content.length; index++) {
              this.data_tax.push({
                line_number: index,
                from_value: res.data.content[index].from_value,
                to_value: res.data.content[index].to_value,
                tax: res.data.content[index].tax,
                basiccal: res.data.content[index].basiccal,
                deductline: res.data.content[index].deductline
              });
            }
            //console.log(res.data.content);
            console.log(this.data_tax);
          }
        })
        .catch(err => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data
          });
        })
        .then(() => {
          this.commitSetShowLoading(false);
        });
    },
    clearForm() {
      this.json_checkin = [];
      // this.dateTime = [
      //   {
      //     date_time: ""
      //   }
      // ];
      // this.form_model = {
      //   usercode: "",
      //   doc_no: "",
      //   remark: "",
      //   editorCode: localStorage._usercode
      // };
      this.data_allowances = [];
      this.jsondatatax.tax_cal = [];
      this.jsondatatax.tax_detail = [];
    },
    save(date) {
      this.$refs.menu.save(date);
      this.$refs.picker.activePicker = "YEAR";
      this.menu = false;
      this.years = new Date(date).toISOString().substr(0, 4);
      console.log("date: " + date);
      console.log("years: " + this.years);

      /**setdata */
       
      console.log("income: ", this.income);
      this.jsondatatax.tax_cal = [];
      this.jsondatatax.tax_detail = [];
      this.jsondatatax.year_tax = this.years;
      this.jsondatatax.creator_code = localStorage._usercode;
      this.jsondatatax.tax_cal = this.data_tax;
      console.log(this.jsondatatax.tax_detail);
      for (let i = 0; i < this.tax_detail.length; i++) {
        if (this.tax_detail[i].name == "add_income") {
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent: this.tax_detail[i].percent,
            max: this.income
          });
        } else if (this.tax_detail[i].name == "expensed") {
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent: this.tax_detail[i].percent,
            max:this.taxsetting.less_exp_base
          });
        } else if (this.tax_detail[i].name == "spouse") {
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent: this.tax_detail[i].percent,
            max:this.taxsetting.reduce_spouse
          });
        } else if (this.tax_detail[i].name == "childen") {
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent:this.tax_detail[i].percent,
            max:this.taxsetting.reduce_child_base
          });
        } else if (this.tax_detail[i].name == "residence") {
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent:this.tax_detail[i].percent,
            max:this.taxsetting.reduce_insurance_base
          });
        }else if(this.tax_detail[i].name == "parent"){
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent:this.tax_detail[i].percent,
            max: this.taxsetting.reduce_parent_base
          });
        }else if(this.tax_detail[i].name == "handicapped"){
           this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent: this.tax_detail[i].percent,
            max: this.taxsetting.reduce_handucap_base
          });
        }else if(this.tax_detail[i].name == "insurance"){
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent:this.tax_detail[i].percent,
            max: this.taxsetting.reduce_inc_residence_base
          });
        }else if(this.tax_detail[i].name == "parent_insurance"){
           this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent: this.tax_detail[i].percent,
            max: this.taxsetting.reduce_parent_insurance_base
          });
        }else if(this.tax_detail[i].name == "long_insurance"){
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent:this.tax_detail[i].percent,
            max:this.taxsetting.reduce_long_insurance
          });
        }else if(this.tax_detail[i].name == "LTF"){
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent:this.tax_detail[i].percent,
            max:this.taxsetting.reduce_ltf
          });
        }else if(this.tax_detail[i].name == "RMF"){
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent:this.tax_detail[i].percent,
            max: this.taxsetting.reduce_rmf
          });
        }
        else {
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent: this.tax_detail[i].percent,
            max: this.tax_detail[i].max
          });
        }
      }
      console.log("data_allowances length" + this.data_allowances.length);
      for (let i = 0; i < this.data_allowances.length; i++) {
        if (this.data_allowances[i].name != null) {
          this.jsondatatax.tax_detail.push({
            name: this.data_allowances[i].name,
            type: this.data_allowances[i].type,
            percent: this.data_allowances[i].percent,
            max: this.data_allowances[i].max
          });
          console.log("add data_allowances");
        } else {
          console.log("not add data_allowances");
        }
      }
     
    },
    async onSave() {
      this.commitSetShowLoading(true);
      // var vue = this;
      // console.log("income: ", vue.income);
      // vue.jsondatatax.tax_cal = [];
      // vue.jsondatatax.tax_detail = [];
      // vue.jsondatatax.year_tax = vue.years;
      // vue.jsondatatax.creator_code = localStorage._usercode;
      // vue.jsondatatax.tax_cal = vue.data_tax;
      // console.log(vue.jsondatatax.tax_detail);
      // for (let i = 0; i < vue.tax_detail.length; i++) {
      //   if (vue.tax_detail[i].name == "add_income") {
      //     vue.jsondatatax.tax_detail.push({
      //       name: vue.tax_detail[i].name,
      //       type: vue.tax_detail[i].type,
      //       percent: vue.tax_detail[i].percent,
      //       max: vue.income
      //     });
      //   } else if (vue.tax_detail[i].name == "expensed") {
      //     vue.jsondatatax.tax_detail.push({
      //       name: vue.tax_detail[i].name,
      //       type: vue.tax_detail[i].type,
      //       percent: vue.tax_detail[i].percent,
      //       max:vue.taxsetting.less_exp_base
      //     });
      //   } else if (vue.tax_detail[i].name == "spouse") {
      //     vue.jsondatatax.tax_detail.push({
      //       name: vue.tax_detail[i].name,
      //       type: vue.tax_detail[i].type,
      //       percent: vue.tax_detail[i].percent,
      //       max:vue.taxsetting.reduce_spouse
      //     });
      //   } else if (vue.tax_detail[i].name == "childen") {
      //     vue.jsondatatax.tax_detail.push({
      //       name: vue.tax_detail[i].name,
      //       type: vue.tax_detail[i].type,
      //       percent:vue.tax_detail[i].percent,
      //       max:vue.taxsetting.reduce_child_base
      //     });
      //   } else if (vue.tax_detail[i].name == "residence") {
      //     vue.jsondatatax.tax_detail.push({
      //       name: vue.tax_detail[i].name,
      //       type: vue.tax_detail[i].type,
      //       percent:vue.tax_detail[i].percent,
      //       max:vue.taxsetting.reduce_insurance_base
      //     });
      //   }else if(vue.tax_detail[i].name == "parent"){
      //     vue.jsondatatax.tax_detail.push({
      //       name: vue.tax_detail[i].name,
      //       type: vue.tax_detail[i].type,
      //       percent:vue.tax_detail[i].percent,
      //       max: vue.taxsetting.reduce_parent_base
      //     });
      //   }else if(vue.tax_detail[i].name == "handicapped"){
      //      vue.jsondatatax.tax_detail.push({
      //       name: vue.tax_detail[i].name,
      //       type: vue.tax_detail[i].type,
      //       percent: vue.tax_detail[i].percent,
      //       max: vue.taxsetting.reduce_handucap_base
      //     });
      //   }else if(vue.tax_detail[i].name == "insurance"){
      //     vue.jsondatatax.tax_detail.push({
      //       name: vue.tax_detail[i].name,
      //       type: vue.tax_detail[i].type,
      //       percent:vue.tax_detail[i].percent,
      //       max: vue.taxsetting.reduce_inc_residence_base
      //     });
      //   }else if(vue.tax_detail[i].name == "parent_insurance"){
      //      vue.jsondatatax.tax_detail.push({
      //       name: vue.tax_detail[i].name,
      //       type: vue.tax_detail[i].type,
      //       percent: vue.tax_detail[i].percent,
      //       max: vue.taxsetting.reduce_parent_insurance_base
      //     });
      //   }else if(vue.tax_detail[i].name == "long_insurance"){
      //     vue.jsondatatax.tax_detail.push({
      //       name: vue.tax_detail[i].name,
      //       type: vue.tax_detail[i].type,
      //       percent:vue.tax_detail[i].percent,
      //       max:vue.taxsetting.reduce_long_insurance
      //     });
      //   }else if(vue.tax_detail[i].name == "LTF"){
      //     vue.jsondatatax.tax_detail.push({
      //       name: vue.tax_detail[i].name,
      //       type: vue.tax_detail[i].type,
      //       percent:vue.tax_detail[i].percent,
      //       max:vue.taxsetting.reduce_ltf
      //     });
      //   }else if(vue.tax_detail[i].name == "RMF"){
      //     vue.jsondatatax.tax_detail.push({
      //       name: vue.tax_detail[i].name,
      //       type: vue.tax_detail[i].type,
      //       percent:vue.tax_detail[i].percent,
      //       max: vue.taxsetting.reduce_rmf
      //     });
      //   }
      //   else {
      //     vue.jsondatatax.tax_detail.push({
      //       name: vue.tax_detail[i].name,
      //       type: vue.tax_detail[i].type,
      //       percent: vue.tax_detail[i].percent,
      //       max: vue.tax_detail[i].max
      //     });
      //   }
      // }
      // console.log("data_allowances length" + vue.data_allowances.length);
      // for (let i = 0; i < vue.data_allowances.length; i++) {
      //   if (vue.data_allowances[i].name != null) {
      //     vue.jsondatatax.tax_detail.push({
      //       name: vue.data_allowances[i].name,
      //       type: vue.data_allowances[i].type,
      //       percent: vue.data_allowances[i].percent,
      //       max: vue.data_allowances[i].max
      //     });
      //     console.log("add data_allowances");
      //   } else {
      //     console.log("not add data_allowances");
      //   }
      // }
      /**setdata */

      //console.log(vue.jsondatatax.tax_detail);
      //console.log("jsondatatax");
      //console.log(vue.jsondatatax);
      await this.data_tax.forEach(function(element, index) {
        if (index + 1 == vue.data_tax.length) {
          element.basiccal = 0;
        } else if (index > 0) {
          element.basiccal =
            element.to_value - vue.data_tax[index - 1].to_value;
        } else {
          element.basiccal = element.to_value;
        }
        element.deductline = element.basiccal * (element.tax / 100);
      });
      // await SettingService.createTaxdetail(vue.jsondatatax)
      //   .then(res => {
      //     //this.getTaxSetting();
      //     console.log(res);
      //   })
      //   .catch(err => {
      //     this.commitToggleAlertDialog({
      //       status: true,
      //       message: err.response.data
      //     });
      //     console.log(err.response.data);
      //   })
      //   .then(() => {
      //      this.commitSetShowLoading(false);
      //    });

      console.log(this.jsontest);
      await SettingService.createTaxdetail(this.jsontest)
        .then(res => {
          //this.getTaxSetting();
          console.log("save success");
        })
        .catch(err => {
          this.commitSetShowLoading(false);
          console.log(err.response.data);
        });
    },
    //*update data*//
    async onUpdate() {
      console.log(this.jsontest);
      await SettingService.updateTaxdetail(this.jsontest)
        .then(res => {
          //this.getTaxSetting();
          console.log("update success");
        })
        .catch(err => {
          this.commitSetShowLoading(false);
          console.log(err.response.data);
        });
    },
    plusTax() {
      let line = this.data_tax.length + 1;
      this.data_tax.push({
        line: line,
        from_value: 0,
        to_value: 0,
        tax: 0,
        basiccal: 0,
        deductline: 0,
      });
    },
    delTax() {
      this.data_tax.splice(-1, 1);
    },
    plusallowances() {
      let line = this.data_allowances.length + 1;
      this.data_allowances.push({
        type: 0,
        percent: 0,
        name: null,
        max: 0
      });
    },
    delallowances() {
      this.data_allowances.splice(-1, 1);
    },
    thousandSep(nStr) {
      nStr = nStr.toFixed(2);
      nStr += "";
      var x = nStr.split(".");
      var x1 = x[0];
      var x2 = x.length > 1 ? "." + x[1] : "";
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      }
      return x1 + x2;
    },
    getTaxDetail() {
      this.jsontest = [];
      //console.log("this.jsondatatax getTaxDetail");
      //console.log(this.jsontest);
      SettingService.getTaxdetail(this.years)
        .then(res => {
          console.log(res);
          this.jsontest = res.data;
        })
        .catch(err => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data
          });
        })
        .then(() => {
          this.commitSetShowLoading(false);
        });
    }
  }
};
</script>

